import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Hero() {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('');
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleCategorySelect = (category: typeof categories[0]) => {
    setSelectedCategory(category.name);
    setIsOpen(false);
    window.open(category.url, '_blank', 'noopener,nofollow');
  };

  return (
    <section className="relative min-h-screen flex items-center pt-16">
      <div className="absolute inset-0 z-0">
        <div className="flex h-full">
          <div className="hidden lg:block lg:w-[60%] h-full relative overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20editorial%20collage%20featuring%20diverse%20curated%20products%20sneakers%20hoodies%20bags%20and%20accessories%20in%20varied%20warm%20earthy%20tones%20on%20textured%20beige%20and%20terracotta%20surface%2C%20soft%20natural%20studio%20lighting%2C%20sophisticated%20editorial%20layout%20with%20asymmetrical%20arrangement%20and%20generous%20negative%20space%2C%20high%20end%20lifestyle%20aesthetic%20with%20organic%20composition&width=900&height=700&seq=hero-collage-v2&orientation=landscape"
              alt="OOPBUY Spreadsheet Produkte Collage"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-white/60 via-white/10 to-transparent" />
          </div>
        </div>
      </div>

      <div className="relative z-10 w-full max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="lg:w-[40%] py-20 md:py-28">
          <p className="text-xs md:text-sm tracking-widest uppercase text-accent-500 font-medium mb-4">
            OOPBUY Spreadsheet 2026
          </p>

          <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
            Die beste Übersicht für günstige Produkte aus China
          </h1>

          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-md">
            Entdecke aktuelle OOPBUY Spreadsheet Listen mit Sneakers, Kleidung, Elektronik und beliebten Produkten. Vergleiche Artikel, Verkäufer und Preise einfach an einem Ort.
          </p>

          <div ref={dropdownRef} className="relative mb-5">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="w-full bg-white border border-secondary-200 hover:border-secondary-300 rounded-xl px-5 py-3.5 flex items-center justify-between text-sm text-foreground-700 transition-all duration-200 cursor-pointer"
            >
              <span className={selectedCategory ? 'text-foreground-900' : 'text-foreground-400'}>
                {selectedCategory || 'Kategorie auswählen...'}
              </span>
              <i className={`ri-arrow-down-s-line text-base transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
            </button>

            {isOpen && (
              <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-secondary-200 rounded-xl overflow-hidden z-20 max-h-72 overflow-y-auto">
                {categories.map((cat) => (
                  <button
                    key={cat.id}
                    onClick={() => handleCategorySelect(cat)}
                    className="w-full text-left px-5 py-3 text-sm text-foreground-700 hover:bg-accent-50 hover:text-foreground-950 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </button>
                ))}
              </div>
            )}
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="bg-primary-500 hover:bg-primary-600 text-white px-7 py-3 rounded-full text-sm font-medium text-center transition-all duration-200 whitespace-nowrap"
            >
              Buy it now
            </a>
            <button
              onClick={() => { navigate('/artikel/oopbuy-spreadsheet-guide'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
              className="border border-secondary-300 hover:border-secondary-400 text-foreground-800 px-7 py-3 rounded-full text-sm font-medium text-center transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Kompletten Guide lesen
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}